export class WhatsApp {
  public static readonly STATUS_CONNECTED = 'CONNECTED'
  public static readonly STATUS_DISCONNECTED = 'DISCONNECTED'
  public static readonly EVENT_QR_CODE = 'qr'
  public static readonly EVENT_READY = 'ready'
  public static readonly EVENT_AUTH = 'auth'
  public static readonly EVENT_RESET = 'reset'
  public static readonly EVENT_CHANGE_STATE = 'change_state'
  public static readonly EVENT_GET_STATE = 'get-state'
  public static readonly EVENT_DESTROY = 'destroy'
  public static readonly EVENT_DISCONNECTED = 'disconnected'
  public static readonly EVENT_CLIENT = 'client'
  public static readonly EVENT_SEND_MESSAGE = 'send-message'
  public static EVENT_AUTH_FAILURE = 'auth_failure'
	public static LOADING_SCREEN = 'loading_screen'
	public static STATUS_OPENING = 'OPENING'
}